export default "__VITE_ASSET__B5a5pdlL__"